import { render, staticRenderFns } from "./animate-img.vue?vue&type=template&id=230fdd67&scoped=true&"
import script from "./animate-img.vue?vue&type=script&lang=js&"
export * from "./animate-img.vue?vue&type=script&lang=js&"
import style0 from "./animate-img.vue?vue&type=style&index=0&id=230fdd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fdd67",
  null
  
)

export default component.exports